import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useHistory } from "react-router-dom";
import "./preview-mode-header.scss";
import { useAppStore } from "@src/stores/zustand/app-store";

export function PreviewModeHeader() {
  const previewModeUrl = process.env.PREVIEW_MODE_SUPPORT_URL;
  const history = useHistory();
  const previewClassroomId = useAppStore((state) => state.previewClassroomId);
  const clearPreviewClassroomId = useAppStore(
    (state) => state.clearPreviewClassroomId
  );

  const handleExitPreview = () => {
    clearPreviewClassroomId();
    if (previewClassroomId) {
      history.push(`/app/classrooms/${previewClassroomId}`);
    } else {
      history.push("/");
    }
  };

  return (
    <div className="preview-mode-header">
      <div className="info-aligned-left">
        <div className="preview-badge">
          <FontAwesomeIcon icon={["far", "eye"]} className="preview-icon" />
          <span>PREVIEW</span>
        </div>
        <span className="warning-text">
          * No data will be tracked, no credentials will be awarded, and no
          prerequisites will be required.
        </span>
      </div>

      <div className="info-aligned-right">
        <a
          href={previewModeUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="learn-more-link"
        >
          Learn more about preview mode
          <FontAwesomeIcon icon={["far", "arrow-up-right-from-square"]} />
        </a>

        <button
          className="close-button"
          onClick={handleExitPreview}
          aria-label="Exit Preview Mode"
        >
          <FontAwesomeIcon icon="fa-regular fa-times" />
        </button>
      </div>
    </div>
  );
}
